<template>
  <div>
    <article class="slds-card slds-card_boundary">
      <div class="slds-card__body slds-card__body_inner">
        <FullCalendar
          default-view="dayGridMonth"
          @eventClick="goToEvent"
          :events="localCampaigns"
          :height="0"
          :locale="calendarLocale"
          :plugins="calendarPlugins" />
      </div>
    </article>
  </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'

export default {
  props: {
    campaigns: Array
  },
  components: {
    FullCalendar
  },
  async created () {
    this.calendarLocale = this.$store.getters['session/locale']
    this.localCampaigns = this.mapCampaigns(this.campaigns)
    this.$store.watch((state, getters) => getters['session/locale'],
      newValue => {
        this.calendarLocale = newValue
      }
    )
  },
  data () {
    return {
      calendarPlugins: [dayGridPlugin],
      localCampaigns: [],
      calendarLocale: ''
    }
  },
  methods: {
    goToEvent (event) {
      this.$router.push(`/campaigns/${event.event.id}`)
    },
    mapCampaigns (campaigns) {
      const campaignTypes = this.$store.getters['settings/settings'].campaignTypes
      const campaignMapping ={
        "Recall": '#D7EDAD',
        "Tactical": '#F5E5B6',
        "New Launch": '#C6EFEE',
        "Newsletter": '#C9EBDC',
        "Contact Plan": '#E6DFD0',
        "Service": '#FFC7C7',
        "Ecommerce": '#D2D6F6',
        "Service Contact Plan": '#DBD0F3',
        "Seasonal": '#F9C5D0',
        "RFID": '#00AE5A',
        "DELIVERY": '#FFFB4C',
        'VHR': '#00AE5A'
      }
      return campaigns.map(campaign => {
        let backgroundColor
        try {
          backgroundColor = campaignMapping[campaign.type] || '#000000';
        } catch (error) {
          console.error(`Error with campaign ${campaign.type}`)
          backgroundColor = '#00AE5A'
        }
        let textColor

        switch (backgroundColor) {

          case '#00AE5A':
          case '#8BC5F5':
          case '#FFBD39':
          case '#000000':
            textColor = '#FFFFFF'
            break
          default:
            textColor = '#000000'
        }

        return {
          allDay: true,
          backgroundColor,
          textColor,
          id: campaign.id,
          date: campaign.startDate,
          title: campaign.name
        }
      })
    }
  },
  mounted () {
    this.$emit('rendered')
  },
  watch: {
    campaigns (campaigns) {
      this.localCampaigns = this.mapCampaigns(campaigns)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~@fullcalendar/core/main.css';
  @import '~@fullcalendar/daygrid/main.css';

  .fc-view table {
    height: 800px;
  }
</style>
